import * as React from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { FloatingButtonGroup, GroupButton } from '../FloatingButtonGroup'

import { FilterIcon } from './styles'

export const Template: React.FC<{
  activeFilterCount: number
  onFilterClick: React.MouseEventHandler<HTMLButtonElement>
  // onSortClick: React.MouseEventHandler<HTMLButtonElement>
}> = ({ activeFilterCount, onFilterClick }) => {
  const {
    magnolia: {
      reviewsPage: { filterSortButton: strings },
    },
  } = useTranslation()

  return (
    <FloatingButtonGroup>
      <GroupButton
        data-testid='filter-sort-button-filter-button'
        aria-label={strings.filter}
        title={strings.filter}
        onClick={onFilterClick}
      >
        <FilterIcon />
        {strings.filter} {activeFilterCount > 0 && `(${activeFilterCount})`}
      </GroupButton>
      {/* Hide sort button until we implement sorting on Yotpo */}
      {/*<GroupButton
        data-testid='filter-sort-button-sort-button'
        aria-label={strings.sort}
        title={strings.sort}
        onClick={onSortClick}
      >
        <SortIcon />
        {strings.sort}
      </GroupButton> */}
    </FloatingButtonGroup>
  )
}
